// extracted by mini-css-extract-plugin
export default {"iconFailure":"IconFailure_iconFailure__5p22a"};